/**
 * `table` — monday's `TableBoardView`, the default view of every board (doc 04 · M1.B4).
 * Only the settings contract lives here in M0; the renderer arrives with M1.B4a.
 */
import { z } from 'zod';
import { defineViewType } from '../types.js';
export const tableViewSettingsSchema = z.looseObject({
    /** Column ids hidden in this view (monday keeps per-view visibility). */
    hidden_columns: z.array(z.string()).default([]),
    /** Column ids in display order; columns missing from the list keep board order. */
    column_order: z.array(z.string()).default([]),
    /** Per-view column widths, keyed by column id. */
    column_widths: z.record(z.string(), z.number().int().positive()).default({}),
    /** Column ids frozen to the left of the horizontal scroll area. */
    frozen_columns: z.array(z.string()).default([]),
    collapsed_groups: z.array(z.string()).default([]),
});
/**
 * The name a board's **own first** table view carries. monday shows that tab as *Main table*
 * while the kind itself is *Table* — the add-view gallery's entry `[cap:sandbox-add-view-menu]`
 * and, on the sandbox, a view added from it takes the kind's name (the Form view added in round
 * 5h is tabbed *Form*, `[cap:sandbox-tabs-bar]`). So `title` is the kind and this constant is
 * the default view's name; `createView` no longer calls a second table view "Main Table" (q396).
 */
export const MAIN_TABLE_VIEW_NAME = 'Main Table';
export const tableView = defineViewType({
    id: 'table',
    title: 'Table',
    mondayViewType: 'TableBoardView',
    kind: 'TABLE',
    settingsSchema: tableViewSettingsSchema,
    defaultSettings: {
        hidden_columns: [],
        column_order: [],
        column_widths: {},
        frozen_columns: [],
        collapsed_groups: [],
    },
    requiredColumnTypes: [],
    supportsFilters: true,
    supportsSort: true,
    supportsGroupBy: true,
    canBeDefault: true,
    implemented: true,
    plannedIn: null,
    gallery: { order: 1, section: 'board-views' },
});
//# sourceMappingURL=index.js.map